// Generated by ReScript, PLEASE EDIT WITH CARE
/* @generated */
'use strict';

let RescriptRelay = require("rescript-relay/src/RescriptRelay.bs.js");
let RescriptRelay_Internal = require("rescript-relay/src/RescriptRelay_Internal.bs.js");

let Types = {};

function unwrap_response_createPasswordResetTokenV5(__x) {
  return RescriptRelay_Internal.unwrapUnion(__x, [
    "CreatePasswordResetTokenInvalidEmailError",
    "PasswordResetTokenCreated"
  ]);
}

let variablesConverter = {"createPasswordResetTokenV5Input":{},"__root":{"input":{"r":"createPasswordResetTokenV5Input"}}};

function convertVariables(v) {
  return RescriptRelay.convertObj(v, variablesConverter, undefined, undefined);
}

let wrapResponseConverter = {"__root":{"createPasswordResetTokenV5":{"u":"response_createPasswordResetTokenV5"}}};

let wrapResponseConverterMap = {
  response_createPasswordResetTokenV5: RescriptRelay_Internal.wrapUnion
};

function convertWrapResponse(v) {
  return RescriptRelay.convertObj(v, wrapResponseConverter, wrapResponseConverterMap, null);
}

let responseConverter = {"__root":{"createPasswordResetTokenV5":{"u":"response_createPasswordResetTokenV5"}}};

let responseConverterMap = {
  response_createPasswordResetTokenV5: unwrap_response_createPasswordResetTokenV5
};

function convertResponse(v) {
  return RescriptRelay.convertObj(v, responseConverter, responseConverterMap, undefined);
}

let Internal = {
  variablesConverter: variablesConverter,
  variablesConverterMap: undefined,
  convertVariables: convertVariables,
  wrapResponseConverter: wrapResponseConverter,
  wrapResponseConverterMap: wrapResponseConverterMap,
  convertWrapResponse: convertWrapResponse,
  responseConverter: responseConverter,
  responseConverterMap: responseConverterMap,
  convertResponse: convertResponse,
  convertWrapRawResponse: convertWrapResponse,
  convertRawResponse: convertResponse
};

let Utils = {};

let node = ((function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v3 = [
  (v2/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "RequestPasswordResetPageRelay_CreatePasswordResetTokenV5Mutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "createPasswordResetTokenV5",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": (v3/*: any*/),
            "type": "CreatePasswordResetTokenInvalidEmailError",
            "abstractKey": null
          },
          {
            "kind": "InlineFragment",
            "selections": (v3/*: any*/),
            "type": "PasswordResetTokenCreated",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "RequestPasswordResetPageRelay_CreatePasswordResetTokenV5Mutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "createPasswordResetTokenV5",
        "plural": false,
        "selections": (v3/*: any*/),
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "a5f72da6b6843a9c6e3b7532d80e054f",
    "id": null,
    "metadata": {},
    "name": "RequestPasswordResetPageRelay_CreatePasswordResetTokenV5Mutation",
    "operationKind": "mutation",
    "text": "mutation RequestPasswordResetPageRelay_CreatePasswordResetTokenV5Mutation(\n  $input: CreatePasswordResetTokenV5Input!\n) {\n  createPasswordResetTokenV5(input: $input) {\n    __typename\n    ... on CreatePasswordResetTokenInvalidEmailError {\n      __typename\n    }\n    ... on PasswordResetTokenCreated {\n      __typename\n    }\n  }\n}\n"
  }
};
})());

let wrap_response_createPasswordResetTokenV5 = RescriptRelay_Internal.wrapUnion;

exports.Types = Types;
exports.unwrap_response_createPasswordResetTokenV5 = unwrap_response_createPasswordResetTokenV5;
exports.wrap_response_createPasswordResetTokenV5 = wrap_response_createPasswordResetTokenV5;
exports.Internal = Internal;
exports.Utils = Utils;
exports.node = node;
/* node Not a pure module */
